import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { parseUnknownToNumber } from "@tsp-core/utils/number";

import { ContractTypeId } from "../types";

export function parseContractTypeId<Input extends unknown>(
  input: Input,
): Input extends ContractTypeId ? ContractTypeId : ContractTypeId | null {
  const id = parseUnknownToNumber(input, "integer");
  if (checkIsNotNullish(id)) {
    return id as ContractTypeId;
  }

  return null as any;
}
